import { DisplayNames } from '@tesla/intl-display-names';
import { getFormats, getSupportedCountries } from '@tesla/intl-phone';
import { parseLocale } from '@tesla/parse-locale';
import { useMemo } from 'react';
export const useCountriesList = (locale = 'en-US', enabledCountries) => {
    const regionNames = useMemo(() => {
        return new DisplayNames([locale], { type: 'region' });
    }, [locale]);
    // Format a list of all countries
    const countries = useMemo(() => {
        const supportedCountries = getSupportedCountries();
        const newCountries = {};
        supportedCountries.forEach((country) => {
            const { countryCode } = getFormats(country);
            if (!enabledCountries || (enabledCountries && enabledCountries.includes(country))) {
                const name = String(regionNames.of(country));
                newCountries[country] = {
                    code: country,
                    name,
                    phone: countryCode,
                };
            }
            else {
                return;
            }
        });
        return newCountries;
    }, [enabledCountries, regionNames]);
    // Pull a default country out of the list, based on the user-agent's location
    const defaultCountry = useMemo(() => {
        let code;
        // parseLocale crashes if the locale isn't in it's expected format
        try {
            const { country: countryCode } = parseLocale(locale);
            code = countryCode;
        }
        catch (e) {
            // If it crashes, fall back to US
            code = 'US';
        }
        if (enabledCountries && !(enabledCountries === null || enabledCountries === void 0 ? void 0 : enabledCountries.includes(code))) {
            code = enabledCountries[0];
        }
        return countries[code];
    }, [countries, enabledCountries, locale]);
    return { countries, defaultCountry };
};
